import New from "csi/table/New";
import xml from "csi/xml";
import declare from "dojo/_base/declare";

const NewSupplierRequestMaster = declare(New, {
	
	// requestType for the request default to Style, otherwise it will be set on the action xml
	requestType: "DataPackageContainerType:Style",

	/**
	 * @override
	 * Set SRM ParentStructureItem attributes based on the hierarchy level
	 */
	toWriter() {
		this.inherited(arguments);
		this.m_cnNew.changeAttribute("RequestType", xml.ATTR_ENUM, this.requestType);

		const parentNode = this.getParent();
		if (!parentNode) {
			return;
		}
		// If we are in a Style, use ParentStructureItem as if it were under the collection of that style
		// else if we are in a material security group, then pass the MSG as a parentStructureItem
		if (xml.enumGetText(this.requestType) === "Style" || parentNode.$Type === "MaterialSecurityGroup") {
			const parentStructureItem = parentNode.$Type == "Style" ? parentNode.__Parent__ : parentNode.$URL;
			const call = this.m_writer.callMethod("Sourcing", "SetParentStructureItem");
			call.addParameter("URL", xml.ATTR_REF, this.m_urlNode);
			call.addParameter("ParentStructureItem", xml.ATTR_REF, parentStructureItem);
		}
	},
});
export = NewSupplierRequestMaster;